import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
  Renderer2,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NgbDropdown,
  NgbModal,
  NgbModalConfig, NgbOffcanvas
} from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { ApiService } from "src/app/services/api";
// import * as moment from 'moment';
import { DOCUMENT } from "@angular/common";
import { PhoneNumberFormat, PhoneNumberUtil } from "google-libphonenumber";
import * as _ from "lodash";
import { CookieService } from "ngx-cookie-service";
import { CountryISO, SearchCountryField } from "ngx-intl-tel-input";
import { forkJoin } from "rxjs";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { TranslatePipe } from "src/app/core/pipes/translate.pipe";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { AppAliasService } from "src/app/core/services/app-alias.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { LocationsService } from "src/app/core/services/locations/locations.service";
import { SalesOrderSummaryService } from "src/app/core/services/sales/orders/orderssummary.service";
import { SalesFetchOrderService } from "src/app/core/services/sales/orders/salesfetchorders.service";
import { SalesTransactionService } from "src/app/core/services/sales/transactions/salestransaction.service.service";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { TimezoneService } from "src/app/services/timezone";
import { AppState } from "src/app/store/app.state";
import { setLoadingSpinner } from "src/app/store/sharedstate/shared.actions";
import { salesTransactionEmployeeFetchStart } from "../../transactions/state/transaction.actions";
import {
  getActiveEmployees,
  getSalesTransactionEmployeeData,
  getSalesTransactions,
} from "../../transactions/state/transaction.selector";
import {
  salesOrderFetchStart,
  salesOrdersFetchStart
} from "../state/salesorder.actions";
import {
  getSalesChildOrders,
  getSalesOrdersData,
  getSalesOrdersMetaData,
  getSalesOrderSummaryData
} from "../state/salesorders.selectors";

@Component({
  selector: "app-orders-list",
  templateUrl: "./orders-list.component.html",
  styleUrls: ["./orders-list.component.scss"],
  providers: [TranslatePipe],
})
export class OrdersListComponent implements OnInit {

  // Remove BreadCrumbs if Rendered for merchants
  @Input() isSuperAdmin: boolean = false;
  @Input() isMerchantId: string = "";
  @Input() isStartDate: any;
  @Input() isEndDate: any;

  taxAliasValue: string = this.cookieService.get("taxAliasValue");

  @ViewChild("myDrop", { static: false }) myDrop: NgbDropdown;
  @Output() changed: EventEmitter<any> = new EventEmitter();
  // @Input() currency: any;

  breadcrumbItems: breadcrumbItem[] = [
    {
      label: "Home",
      active: false,
      url: "/home",
    },
    {
      label: "Sales",
      active: false,
      url: "/sales/transactions/sales-home",
      // url:'/sales/transactions'
    },
    {
      label: "Orders",
      active: true,
      url: "",
    },
  ];
  isOpen: boolean = false;
  activeEmployees$: any = [];
  transactions$: any = [];
  refundProductList: any = [];
  tempData: any = {};
  // input phone initilization
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[];
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  httpOptions2 = {};
  params: any = new HttpParams();
  disableSendbtn = true;
  orders$: any[] = [];
  childOrders$: any[] = [];
  metaData$: any = {};
  orderSize: number = 0;
  itemsPP: any = 10;
  offsetOrder: any = 100;
  p: any = 1;
  serverId: any = "";
  ngOtpInput: any;
  employeesData$: any = [];
  dateTimearray: any = [];
  orderTypes: any = [];
  refundOptions: any = [];
  daterange: any = {};
  startDate: any = this.timezoneService.get()().startOf("day");
  endDate: any = this.timezoneService.get()().endOf("day");
  startDateDisplay: any = this.startDate.unix();
  endDateDisplay: any = this.endDate.unix();
  fundType = "";
  closeOrderLoader: boolean = false;
  startDateDisplayFormatted: any = this.timezoneService
    .get()
    .unix(this.startDateDisplay)
    .format("MMM Do YYYY");
  endDateDisplayFormatted: any = this.timezoneService
    .get()
    .unix(this.endDateDisplay)
    .format("MMM Do YYYY");
  storeId: any = this.cookieService.get("storeId");
  merchantId: any = this.cookieService.get("merchantId");
  employeeSelected: any = "";
  orderTypeSelected: any = "";
  orderStatusSelected: any = "";
  orderNumber: any = "";
  currency: any = this.cookieService.get("currency");
  options: any = {
    locale: { format: "YYYY-MM-DD" },
    startDate: this.timezoneService.get()().startOf("day"),
    endDate: this.timezoneService.get()().endOf("day"),
    alwaysShowCalendars: true,
    ranges: {
      Today: [this.timezoneService.get()(), this.timezoneService.get()()],
      Yesterday: [
        this.timezoneService.get()().subtract(1, "days"),
        this.timezoneService.get()().subtract(1, "days"),
      ],
      "Last 7 Days": [
        this.timezoneService.get()().subtract(6, "days"),
        this.timezoneService.get()(),
      ],
      "Last 30 Days": [
        this.timezoneService.get()().subtract(29, "days"),
        this.timezoneService.get()(),
      ],
      "This Month": [
        this.timezoneService.get()().startOf("month"),
        this.timezoneService.get()().endOf("month"),
      ],
      "Last Month": [
        this.timezoneService.get()().subtract(1, "month").startOf("month"),
        this.timezoneService.get()().subtract(1, "month").endOf("month"),
      ],
    },
  };
  NeworderStaus = [
    { value: "1", name: "Ordering " },
    { value: "2", name: "Payment in Progress" },
    { value: "3", name: "Paid " },
    { value: "4", name: "Completed " },
    { value: "5", name: "Partially Refunded " },
    { value: "6", name: "Refunded " },
    { value: "7", name: "Cancelled " },
  ];
  GLOBALURL: string;
  disableCloseBtn: boolean = false;
  selectedOrderId: any;
  constructor(
    private translatePipe: TranslatePipe,
    private http: HttpClient,
    private toastr: AlertService,
    private cookieService: CookieService,
    private store: Store<AppState>,
    private route: Router,
    private modalService: NgbModal,
    private salesOrderService: SalesFetchOrderService,
    private renderer: Renderer2,
    private elRef: ElementRef,
    private modalConfig: NgbModalConfig,
    private locService: locationBroadcastService,
    private ApiService: ApiService,
    private orderService: SalesOrderSummaryService,
    public offcanvasService: NgbOffcanvas,
    private BreadcrumbService: BreadcrumbService,
    private locationService: LocationsService,
    private timezoneService: TimezoneService,
    private transactionService: SalesTransactionService,
    private AppAliasService: AppAliasService,
    @Inject(DOCUMENT) private documents: any,
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
    this.salesOrderService.GLOBALURL = this.ApiService.getBaseURL();
  }
  Ruler: Boolean = false;
  transactionTimeArray: any[] = [];
  //location service check if load data
  isLoadData = false;
  ngOnInit(): void {
    const userCountry = this.locationService.getUserCountry();
    this.preferredCountries = userCountry === CountryISO.UnitedKingdom
      ? [CountryISO.UnitedKingdom]
      : [userCountry, CountryISO.UnitedKingdom];
    const element = this.renderer.selectRootElement('.main-content', true);
    this.renderer.setStyle(element, 'overflow', 'hidden');
    console.log("this.isSuperAdmin", this.isSuperAdmin)
    if (!this.isSuperAdmin) {
      this.BreadcrumbService.setValue(this.breadcrumbItems);
    }

    if(this.isSuperAdmin) {
      this.merchantId = this.isMerchantId;
      this.storeId = "*";
    }

    this.AppAliasService.getStoreValue().subscribe((res) => {
      // this.storeId = res;
      if (res === '*') {
        this.toastr.error('Please select a store');
        return;
      }
    }
    );
    this.modalConfig.backdrop = "static";
    this.modalConfig.keyboard = false;

    if (!Boolean(this.currency)) {
      this.currency = "$";
    }
    // if (!this.storeId || this.storeId === '*') {
    //   this.toastr.error('Please select a store');
    //   return;
    // }

    if (this.storeId != "*") {
      this.params = this.params.set("storeId", this.storeId);
      // this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.httpOptions2 = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };
    } else {
      this.params = this.params.set("storeId", this.storeId);
      // this.httpOptions = { headers: new HttpHeaders(this.headerToken) };
      this.httpOptions2 = {
        headers: new HttpHeaders(this.headerToken),
        params: this.params,
      };
    }
    // this.getSettings();
    // this.transactionService
    //   .getSalesTransactionsEmployee()
    //   .subscribe((result) => {
    //     let response = result;
    //     // console.log("respomse_EMPLOYEES", response)
    //     var temp = {};
    //     response.response.forEach((element) => {
    //       if (element.status === 1) {
    //         temp = {
    //           id: element.employeeId,
    //           name:
    //             element?.employeeFirstName + " " + element?.employeeLastName,
    //         };
    //         this.activeEmployees$.push(temp);
    //       }
    //       console.log("activeEmployees$_FROM_SERVICE", this.activeEmployees$);
    //       // temp = {
    //       //     id: element.employeeId,
    //       //     name:
    //       //         element?.employeeFirstName +
    //       //         " " +
    //       //         element?.employeeLastName
    //       // };
    //       // this.employeesData.push(temp);
    //     });
    //     // this.activeEmployees$ = [...response.response];
    //   });
    if (!this.isSuperAdmin) {
      this.store.select(getSalesOrderSummaryData).subscribe((data) => {
        if (data) {
          console.log(data);
          this.summary = {
            ...data,
            orders: data.orders !== undefined ? data.orders : [],
            closedOrders:
              data.closedOrders !== undefined ? data.closedOrders : [],
            netSales: data.netSales !== undefined ? data.netSales : 0,
            discounts: data.discounts !== undefined ? data.discounts : 0,
            serviceCharges:
              data.serviceCharges !== undefined ? data.serviceCharges : 0,
            deliveryAmount:
              data.deliveryAmount !== undefined ? data.deliveryAmount : 0,
            promoCodeAmount:
              data.promoCodeAmount !== undefined ? data.promoCodeAmount : 0,
            grossSales: data.grossSales !== undefined ? data.grossSales : 0,
            tax: data.tax !== undefined ? data.tax : 0,
            tips: data.tips !== undefined ? data.tips : "0.00",
            totalAmount: data.totalAmount !== undefined ? data.totalAmount : 0,
          };
        }
      });
      // this.store.select(getSalesEmployeeData).subscribe((result) => {
      //   this.employeesData$ = result;
      // });
      this.store.select(getSalesTransactionEmployeeData).subscribe((result) => {
        let response = result;
        this.employeesData$ = [...response];
      });
      this.store.select(getSalesOrdersData).subscribe((result) => {
        console.log("orders list=>", result);
        this.orders$ = result;
      });
      this.store.select(getActiveEmployees).subscribe((result) => {
        let response = result;
        this.activeEmployees$ = [...response];
        console.log("activeEmployees$_FROM_STORE", this.activeEmployees$);
      });
      this.store.select(getSalesTransactions).subscribe((result) => {
        let response = result;
        console.log("respomse", response);

        this.transactions$ = [...response];
        setTimeout(() => {
          this.setPaginateTexts();
        }, 100)
      });
      this.store.select(getSalesOrdersMetaData).subscribe((result) => {
        this.metaData$ = result;
      });
      this.store.select(getSalesChildOrders).subscribe((result) => {
        this.childOrders$ = result;
      });
      this.fetchingSummary();
    }

    // this.transactionTimeArray = [
    //   { id: "0", text: "12:00 AM" },
    //   { id: "1", text: "01:00 AM" },
    //   { id: "2", text: "02:00 AM" },
    //   { id: "3", text: "03:00 AM" },
    //   { id: "4", text: "04:00 AM" },
    //   { id: "5", text: "05:00 AM" },
    //   { id: "6", text: "06:00 AM" },
    //   { id: "7", text: "07:00 AM" },
    //   { id: "8", text: "08:00 AM" },
    //   { id: "9", text: "09:00 AM" },
    //   { id: "10", text: "10:00 AM" },
    //   { id: "11", text: "11:00 AM" },
    //   { id: "12", text: "12:00 PM" },
    //   { id: "13", text: "01:00 PM" },
    //   { id: "14", text: "02:00 PM" },
    //   { id: "15", text: "03:00 PM" },
    //   { id: "16", text: "04:00 PM" },
    //   { id: "17", text: "05:00 PM" },
    //   { id: "18", text: "06:00 PM" },
    //   { id: "19", text: "07:00 PM" },
    //   { id: "20", text: "08:00 PM" },
    //   { id: "21", text: "09:00 PM" },
    //   { id: "22", text: "10:00 PM" },
    //   { id: "23", text: "11:00 PM" },
    //   { id: "24", text: "12:00 AM" },
    // ];

    if (this.cookieService.check("permissionNameOrder")) {
      this.account = this.cookieService.get("loggedAccount");
      this.currency = this.cookieService.get("currency") || "$";

      this.transactionTimeArray = [
        { id: "0", text: "12:00 AM" },
        { id: "1", text: "01:00 AM" },
        { id: "2", text: "02:00 AM" },
        { id: "3", text: "03:00 AM" },
        { id: "4", text: "04:00 AM" },
        { id: "5", text: "05:00 AM" },
        { id: "6", text: "06:00 AM" },
        { id: "7", text: "07:00 AM" },
        { id: "8", text: "08:00 AM" },
        { id: "9", text: "09:00 AM" },
        { id: "10", text: "10:00 AM" },
        { id: "11", text: "11:00 AM" },
        { id: "12", text: "12:00 PM" },
        { id: "13", text: "01:00 PM" },
        { id: "14", text: "02:00 PM" },
        { id: "15", text: "03:00 PM" },
        { id: "16", text: "04:00 PM" },
        { id: "17", text: "05:00 PM" },
        { id: "18", text: "06:00 PM" },
        { id: "19", text: "07:00 PM" },
        { id: "20", text: "08:00 PM" },
        { id: "21", text: "09:00 PM" },
        { id: "22", text: "10:00 PM" },
        { id: "23", text: "11:00 PM" },
        { id: "24", text: "12:00 AM" },
      ];
      // jQuery(".allpageLoader").css("display", "block");
      this.refundOptions = [
        "QSA",
        "Food Cold",
        "Too Much Salt",
        "Undercooked",
        "OverCooked",
        "Prepared Incorrectly",
        "Food Allergy",
        "Foreign Object in Food",
        "Wrong Menu Item",
        "Out of Stock",
        "Other",
      ];
      this.orderTypes = [
        { id: 1, text: "Dine-In" },
        { id: 2, text: "Bar" },
        { id: 3, text: "Takeout" },
        { id: 4, text: "App" },
        { id: 5, text: "Delivery" },
        { id: 6, text: "Ahead" },
        { id: 7, text: "Banquet" },
        { id: 8, text: "Online Ordering" },
        { id: 10, text: "Drive Thru" },
      ];
      this.dateTimearray = [
        { id: "0", text: "12:00 AM" },
        { id: "1", text: "01:00 AM" },
        { id: "2", text: "02:00 AM" },
        { id: "3", text: "03:00 AM" },
        { id: "4", text: "04:00 AM" },
        { id: "5", text: "05:00 AM" },
        { id: "6", text: "06:00 AM" },
        { id: "7", text: "07:00 AM" },
        { id: "8", text: "08:00 AM" },
        { id: "9", text: "09:00 AM" },
        { id: "10", text: "10:00 AM" },
        { id: "11", text: "11:00 AM" },
        { id: "12", text: "12:00 PM" },
        { id: "13", text: "01:00 PM" },
        { id: "14", text: "02:00 PM" },
        { id: "15", text: "03:00 PM" },
        { id: "16", text: "04:00 PM" },
        { id: "17", text: "05:00 PM" },
        { id: "18", text: "06:00 PM" },
        { id: "19", text: "07:00 PM" },
        { id: "20", text: "08:00 PM" },
        { id: "21", text: "09:00 PM" },
        { id: "22", text: "10:00 PM" },
        { id: "23", text: "11:00 PM" },
        { id: "24", text: "12:00 AM" },
      ];

      if (!this.isLoadData) {
        if (!this.isSuperAdmin) {
          this.getEmployees();
        }
        this.getNumberCountOrders("firstLoad");
      }
    } else {
      this.route.navigateByUrl("/home");
    }
  }

  setPaginateTexts() {
    const next = document.querySelector(".pagination-next a");
    const prev = document.querySelector(".pagination-previous a");
    const nextDisabled = document.querySelector(".pagination-next > span");
    const prevDisabled = document.querySelector(".pagination-previous > span");

    this.translatePipe.transform("Next")
      .subscribe(res => {
        if (next) {
          next.textContent = res;
        }
        if (nextDisabled) {
          nextDisabled.textContent = res;
        }
      },
      (error) => {});

    this.translatePipe.transform("Previous")
      .subscribe(res => {
        if (prev) {
          prev.textContent = res;
        }
        if (prevDisabled) {
          prevDisabled.textContent = res;
        }
      },
      (error) => {});
  }

  async selectedDate(value: any) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.startDate = value.start;
    this.endDate = value.end;
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YYYY");
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YYYY");

    const hour = Number(this.startTime.split(["."])[0]) || 0;
    const minutes = this.startTime.split(["."])[1] || 0;
    this.startTimeFormatted = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(hour, "hours")
      .add(minutes, "minutes")
      .format("HH:mm a");
    this.startDate = this.timezoneService
      .get()(this.startDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });

    const hourEnd = Number(this.endTime.split(["."])[0]) || 0;
    const minutesEnd = this.endTime.split(["."])[1] || 0;
    this.endTimeFormatted = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", hourEnd)
      .add("minutes", minutesEnd)
      .format("HH:mm a");
    this.endDate = this.timezoneService
      .get()(this.endDate)
      .subtract(0, "days")
      .set({ hours: hourEnd })
      .set({ minutes: minutesEnd });

    this.startDateDisplay = this.startDate.format("MMM Do YYYY");
    this.endDateDisplay = this.endDate.format("MMM Do YYYY");

    // await this.getNumberCountOrders();
    if (
      this.ClosingDay == "Next Day" &&
      this.startDateDisplay == this.endDateDisplay
    ) {
      window.alert(
        "Same start and end date cannot be selected with Next Day option."
      );
    } else {
      // this.fetchRerport(this.startDate.unix(),this.endDate.unix());
      // this.startDate.unix()
      // this.endDate.unix()
      await this.getNumberCountOrders();
    }
  }
  startTime: any = "";
  startTimeFormatted: any = "";
  endTime: any = "";
  endTimeFormatted: any = "";
  clickDayAllOption(): void {
    this.showItemCountPP = 0;
    this.p = 1;
    this.Ruler = false;
    this.startTime = "";
    this.endTime = "";
    this.endTimeFormatted = "";
    this.startTimeFormatted = "";
    this.myDrop.close();
    this.getNumberCountOrders();
  }
  clickCustomizeOption(): void {
    this.Ruler = true;
  }
  // changeStartTimeOrder(e) {
  //   this.startTime = e;
  //   this.dateTimearray.forEach((element) => {
  //     if (element.id == this.startTime) {
  //       this.startTimeFormatted = element.text;
  //     }
  //   });
  //   this.checkTimeOrder();
  // }

  // changeEndTimeOrder(e: any) {
  //   this.endTime = e;
  //   this.dateTimearray.forEach((element) => {
  //     if (element.id == this.endTime) {
  //       this.endTimeFormatted = element.text;
  //     }
  //   });
  //   this.checkTimeOrder();
  // }
  dateTimeArray: any[] = [];
  ClosingDay = "Same Day";

  getSettings() {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    this.http.get(this.GLOBALURL + "/settings", this.httpOptions2).subscribe(
      (resp: any) => {
        // this.store.dispatch(setLoadingSpinner({ status: false }));
        if (resp.success === 0) {
          this.toastr.error(resp.message);
        } else {
          let hour = 23;
          let minutes = 59;
          let StartOfHourByDay = resp.response.find(
            (el) => el.settingName === "StartOfHourByDay"
          );
          let EndOfHourByDay = resp.response.find(
            (el) => el.settingName === "EndOfHourByDay"
          );
          let ClosingDay = resp.response.find(
            (el) => el.settingName === "ClosingDay"
          );
          if (!StartOfHourByDay || !EndOfHourByDay || !ClosingDay) {
            this.setTimes(0, 0, 23, 30);
            StartOfHourByDay = "00:00";
            EndOfHourByDay = "23:59";
            ClosingDay = "Same Day";
          } else {
            StartOfHourByDay = StartOfHourByDay.settingValue;
            EndOfHourByDay = EndOfHourByDay.settingValue;
            ClosingDay = ClosingDay.settingValue;
          }
          this.ClosingDay = ClosingDay;
          let dateTimeToday = this.timezoneService.get()();
          const startHour = Number(StartOfHourByDay.split([":"])[0]);
          const startMinutes = Number(StartOfHourByDay.split([":"])[1]);
          this.startDate = this.timezoneService
            .get()(this.startDate)
            .set({ hours: startHour })
            .set({ minutes: startMinutes });
          this.startDateDisplay = this.timezoneService
            .get()(this.startDate)
            .format("MMM Do YYYY");

          hour = Number(EndOfHourByDay.split([":"])[0]);
          minutes = Number(EndOfHourByDay.split([":"])[1]);
          this.endDate = this.timezoneService
            .get()(this.endDate)
            .set({ hours: hour })
            .set({ minutes });
          this.endDateDisplay = this.timezoneService
            .get()(this.endDate)
            .format("MMM Do YYYY");
          this.options.startDate = this.startDate;
          if (
            this.startDate.diff(dateTimeToday) > 0 &&
            this.endDate.diff(dateTimeToday) > 0
          ) {
            /**
             * Current time is before restaurant hours
             * Date set would be yesterday and today
             */
            this.startDate = this.timezoneService
              .get()(this.startDate)
              .subtract(1, "days");
            this.startDateDisplay = this.timezoneService
              .get()(this.startDate)
              .format("MMM Do YYYY");
            this.options.startDate = this.startDate;
          } else if (
            this.startDate.diff(dateTimeToday) > 0 &&
            this.endDate.diff(dateTimeToday) < 0
          ) {
            /**
             * Current time is after restaurant hours
             * Date set would be tomorrow and day after tomorrow
             */
            this.startDate = this.timezoneService
              .get()(this.startDate)
              .add(1, "days");
            this.startDateDisplay = this.timezoneService
              .get()(this.startDate)
              .format("MMM Do YYYY");
            this.options.startDate = this.startDate;
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.endDate)
              .add(2, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.endDateDisplay = this.timezoneService
              .get()(this.endDate)
              .format("MMM Do YYYY");
            this.options.endDate = this.endDate;
          } else {
            /**
             * Current time is within restaurant hours
             * Date set would be today and tomorrow
             */
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.endDate)
              .add(1, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.endDateDisplay = this.timezoneService
              .get()(this.endDate)
              .format("MMM Do YYYY");
            this.options.endDate = this.endDate;
          }
          this.setTimes(startHour, startMinutes, hour, minutes);
          if (this.ClosingDay === "Same Day") {
            hour = Number(EndOfHourByDay.split([":"])[0]);
            minutes = Number(EndOfHourByDay.split([":"])[1]);
            this.endDate = this.timezoneService
              .get()(this.startDate)
              .add(0, "days")
              .set({ hours: hour })
              .set({ minutes });
            this.options.endDate = this.options.startDate;
            this.endDateDisplay = this.timezoneService
              .get()(this.options.endDate)
              .format("MMM Do YYYY");
          }
        }
        // this.getNumberCountPayments();
        // this.getEmployees();
        // this.loadPage();
        // this.getNumberCountPayments();
      },
      (error) => {
        this.store.dispatch(setLoadingSpinner({ status: false }));
        const message = this.ApiService.errorMessage(error);
        this.toastr.error(message);
      }
    );
  }

  setTimes(
    startHour: number,
    startMinutes: number,
    endHour: number,
    endMinutes: number
  ) {
    this.dateTimeArray = [];
    startHour = 0;
    startMinutes = 0;
    endHour = 23;
    endMinutes = 60;
    for (let time = 0; time <= 23; time++) {
      let dateTime = this.timezoneService.get()().startOf("day");
      if (time >= startHour && time <= endHour) {
        dateTime.add(time, "hour");
        this.dateTimeArray.push({
          id: time.toString(),
          text: time <= 9 ? `0${time}:00` : `${time}:00`,
        });
        if (time + 1 > endHour) {
          if (60 <= endMinutes) {
            for (let index = 1; index < 59; index++) {
              let minutes = index <= 9 ? `0${index}` : index;
              this.dateTimeArray.push({
                id: `${time}.${index}`,
                text: time <= 9 ? `0${time}:${minutes}` : `${time}:${minutes}`,
              });
            }
            this.dateTimeArray.push({
              id: `${time}.59`,
              text: time <= 9 ? `0${time}:59` : `${time}:59`,
            });
            break;
          }
        }
        if (60 <= endMinutes) {
          for (let index = 1; index <= 59; index++) {
            let minutes = index <= 9 ? `0${index}` : index;
            this.dateTimeArray.push({
              id: `${time}.${index}`,
              text: time <= 9 ? `0${time}:${minutes}` : `${time}:${minutes}`,
            });
          }
        }
      }
    }
    let timeStart = this.startDate.format("HH:mm");
    let timeEnd = this.endDate.format("HH:mm");
    this.startTimeFormatted = this.startDate.format("HH:mm a");
    this.endTimeFormatted = this.endDate.format("HH:mm a");
    this.startTime = this.dateTimeArray.find((x) => x.text === timeStart).id;
    this.endTime = this.dateTimeArray.find((x) => x.text === timeEnd).id;
  }

  sameDayIsChecked() {
    return this.ClosingDay === "Same Day";
  }
  nextDayIsChecked() {
    return this.ClosingDay === "Next Day";
  }
  selectClosingDay($event) {
    this.ClosingDay = $event;
  }

  timeFilter() {
    this.changeStartTimeOrder();
    this.changeEndTimeOrder();
  }

  changeStartTimeOrder() {
    const hour = Number(this.startTime.split(["."])[0]) || 0;
    const minutes = this.startTime.split(["."])[1] || 0;
    this.startTimeFormatted = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(hour, "hours")
      .add(minutes, "minutes")
      .format("HH:mm a");
    this.startDate = this.timezoneService
      .get()(this.startDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });
    console.log("startTime", this.startTimeFormatted, this.startDate);
  }
  changeEndTimeOrder() {
    const hour = Number(this.endTime.split(["."])[0]) || 0;
    const minutes = this.endTime.split(["."])[1] || 0;
    this.endTimeFormatted = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", hour)
      .add("minutes", minutes)
      .format("HH:mm a");
    //change subtract
    this.endDate = this.timezoneService
      .get()(this.endDate)
      .subtract(0, "days")
      .set({ hours: hour })
      .set({ minutes: minutes });
    console.log("endTime", this.endTimeFormatted, this.endDate, hour, minutes);
    this.checkTimeOrder();
    this.offcanvasService.dismiss("cross click");
  }
  timeDiasbleValidation() {
    const startHour = Number(this.startTime.split(["."])[0]) || 0;
    const startMinutes = this.startTime.split(["."])[1] || 0;
    const time1 = this.timezoneService
      .get()(this.startDate)
      .startOf("day")
      .add(startHour, "hours")
      .add(startMinutes, "minutes")
      .format("HH:mm");

    const endhour = Number(this.endTime.split(["."])[0]) || 0;
    const endMinutes = this.endTime.split(["."])[1] || 0;
    const time2 = this.timezoneService
      .get()(this.endDate)
      .startOf("day")
      .add("hour", endhour)
      .add("minutes", endMinutes)
      .format("HH:mm");
    // const time1 = this.startDate.text;
    // const time2 = this.endDate.text;

    // Parse the time strings to create Date objects
    const date1 = new Date(`1970-01-01T${time1}`);
    const date2 = new Date(`1970-01-01T${time2}`);

    // Compare the dates
    if (date1 < date2) {
      return false;
    } else {
      return true;
    }
  }

  // changeStartTimeOrder(e) {
  //   this.transactionTimeArray.forEach((element) => {
  //     if (element.id == this.startTime) {
  //       this.startTimeFormatted = element.text;
  //       const hour = Number(this.startTime) || 0;
  //       const minutes = 0; // since we dont select mins in drop down
  //       this.startDateDisplay = this.timezoneService
  //         .get()(this.startDate)
  //         .subtract(0, "days")
  //         .set({ hours: hour })
  //         .set({ minutes: minutes })
  //         .unix();
  //     }
  //   });
  //   this.checkTimeOrder();
  // }

  // changeEndTimeOrder(e: any) {
  //   this.transactionTimeArray.forEach((element) => {
  //     if (element.id == this.endTime) {
  //       this.endTimeFormatted = element.text;
  //       const hour = Number(this.endTime) || 0;
  //       const minutes = 0; // since we dont select mins in drop down
  //       this.endDateDisplay = this.timezoneService
  //         .get()(this.endDate)
  //         .subtract(0, "days")
  //         .set({ hours: hour })
  //         .set({ minutes: minutes })
  //         .unix();
  //     }
  //   });
  //   this.checkTimeOrder();
  // }

  checkTimeOrder() {
    // console.log("START_TIME_DAY-PART", this.startTime);
    // console.log("END_TIME_DAY-PART", this.endTime);
    const startTimeNumber = Number(this.startTime);
    const endTimeNumber = Number(this.endTime);
    const startDate = this.startDate.unix();
    const endDate = this.endDate.unix();
    // console.log("START_TIME_DAY-PART", startTimeNumber);
    if (startTimeNumber != endTimeNumber) {
      if (this.startTime !== "" && this.endTime !== "") {
        this.p = 1;
        this.showItemCountPP = 0;
        this.myDrop.close();
        this.getNumberCountOrders();
      }
    } else if (startTimeNumber == endTimeNumber && this.endTime != "") {
      this.toastr.error("Start time should be less than End time.");
      return;
    } else {
      return;
    }
  }
  closeFilterCanvas() {
    this.offcanvasService.dismiss("cross click");
    this.OpenDetails = "mainMenu";
  }
  NewchangeTypeStatus(e: any) {
    console.log("NewchangeTypeStatus", e);

    this.closeFilterCanvas();
    this.showItemCountPP = 0;
    this.p = 1;
    this.orderTypeSelected = e;
    this.getNumberCountOrders();
  }

  changeTypeStatus(e: any) {
    this.showItemCountPP = 0;
    this.p = 1;
    console.log("e.target.value", typeof(e.target.value), e.target.value);
    this.orderTypeSelected = e.target.value;
    console.log("Order-Type", this.orderTypeSelected);
    this.getNumberCountOrders();
  }
  NewchangeOrderStatus(e: any) {
    this.closeFilterCanvas();
    this.showItemCountPP = 0;
    this.p = 1;
    this.orderStatusSelected = e;
    this.getNumberCountOrders();
  }
  changeOrderStatus(e) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.orderStatusSelected = e.target.value;
    this.getNumberCountOrders();
  }

  changeStore(event: any) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.currency = this.cookieService.get("currency") || "$";
    this.storeId = event;
    this.getSettings();
    this.getEmployees();
    this.fetchingSummary();
    this.getNumberCountOrders();
  }
  summary: any = {
    orders: 0,
    closedOrders: 0,
    netSales: "0.00",
    discounts: "0.00",
    serviceCharges: "0.00",
    deliveryAmount: "0.00",
    promoCodeAmount: "0.00",
    grossSales: "0.00",
    tax: "0.00",
    tips: "0.00",
    totalAmount: "0.00",
  };

  cleanSummary: any = {
    orders: 0,
    closedOrders: 0,
    netSales: "0.00",
    discounts: "0.00",
    serviceCharges: "0.00",
    deliveryAmount: "0.00",
    promoCodeAmount: "0.00",
    grossSales: "0.00",
    tax: "0.00",
    tips: "0.00",
    totalAmount: "0.00",
  };
  data: any;
  //fetching order summary
  async fetchingSummary() {
    let startTime = this.timezoneService
    .get()
    .unix(this.startDateDisplay)
    .format("HH:mm");

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

    this.data = {
      merchantId: this.merchantId,
      storeId: this.storeId,
      employeeSelected: this.employeeSelected,
      orderTypeSelected: this.orderTypeSelected,
      orderStatusSelected: this.orderStatusSelected,
      orderNumber: this.orderNumber,
      startDateDisplay: this.startDateDisplay,
      endDateDisplay: this.endDateDisplay,
      startTime: startTime,
      endTime: endTime,
    };
    this.store.dispatch(salesOrdersFetchStart(this.data));
  }
  //fetch employee details based on locations
  async getEmployees() {
    // const superAdminPayload = {
    //   merchantId: this.merchantId,
    //   storeId: this.storeId,
    // };
    // this.store.dispatch(salesOrderFecthEmployeeStart());
    this.store.dispatch(salesTransactionEmployeeFetchStart());
  }

  lastStartDate: any;
  lastEndDate: any;
  //fetch orders
  async getNumberCountOrders(state?: any) {
    this.store.dispatch(setLoadingSpinner({ status: true }));
    var startDate = this.timezoneService.get()(this.startDate);
    var endDate = this.timezoneService.get()(this.endDate);
    this.startDateDisplay = this.startDate.unix();
    this.endDateDisplay = this.endDate.unix();
    var totalDays = endDate.diff(startDate, "days");
    if (totalDays == 0) {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(1, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    } else {
      var selectedDate = this.timezoneService.get()(this.startDate);
      this.lastStartDate = selectedDate
        .clone()
        .subtract(totalDays, "days")
        .startOf("day")
        .unix();
      this.lastEndDate = selectedDate
        .clone()
        .subtract(1, "days")
        .endOf("day")
        .unix();
    }
    // if(state === 'firstLoad') {
    //   console.log("THIS_IS_FIRST_LOAD")
    //   let StartOfHourByDay: any = localStorage.getItem("StartOfHourByDay");
    //   let EndOfHourByDay: any = localStorage.getItem("EndOfHourByDay");
    //   let ClosingDayValue: any = localStorage.getItem("ClosingDay");
    //   const startHour = Number(StartOfHourByDay.split([":"])[0]);
    // const startMinutes = Number(StartOfHourByDay.split([":"])[1]);
    // console.log("startHour", startHour);
    // console.log("startMinutes", startMinutes);
    // // let startDateWithTime = this.getCustomDate(this.startDate, startHour, startMinutes);
    // this.startDate = this.timezoneService
    //   .get()(this.startDate)
    //   .hour(startHour)
    //   .minute(startMinutes);
    // this.startTimeFormatted = this.startDate.format("HH:mm a");
    // // console.log("this.startTimeFormatted", this.startTimeFormatted);
    // // console.log("THIS>startDate", this.startDate.unix())
    // let hour = Number(EndOfHourByDay.split([":"])[0]);
    // let minutes = Number(EndOfHourByDay.split([":"])[1]);
    // this.endDate = this.timezoneService
    //   .get()(this.endDate)
    //   .hour(hour)
    //   .minute(minutes);
    // this.endTimeFormatted = this.endDate.format("HH:mm a");

    // this.ClosingDay = ClosingDayValue;
    // let dateTimeToday = this.timezoneService.get()();
    // if (
    //   this.startDate.diff(dateTimeToday) > 0 &&
    //   this.endDate.diff(dateTimeToday) > 0
    // ) {
    //   /**
    //    * Current time is before restaurant hours
    //    * Date set would be yesterday and today
    //    */
    //   console.log("yesterday and today")
    //   this.startDate = this.timezoneService
    //     .get()(this.startDate)
    //     .subtract(1, "days");
    //   this.startDateDisplay = this.timezoneService
    //     .get()(this.startDate)
    //     .format("MMM Do YYYY")

    //   this.options.startDate = this.startDate;
    // } else if (
    //   this.startDate.diff(dateTimeToday) > 0 &&
    //   this.endDate.diff(dateTimeToday) < 0
    // ) {
    //   console.log("tomorrow and day after tomorrow")
    //   /**
    //    * Current time is after restaurant hours
    //    * Date set would be tomorrow and day after tomorrow
    //    */
    //   this.startDate = this.timezoneService
    //     .get()(this.startDate)
    //     .add(1, "days");
    //   this.startDateDisplay = this.timezoneService
    //     .get()(this.startDate)
    //     .format("MMM Do YYYY");
    //   this.options.startDate = this.startDate;
    //   hour = Number(EndOfHourByDay.split([":"])[0]);
    //   minutes = Number(EndOfHourByDay.split([":"])[1]);
    //   this.endDate = this.timezoneService
    //     .get()(this.endDate)
    //     .add(2, "days")
    //     .set({ hours: hour })
    //     .set({ minutes });
    //   this.endDateDisplay = this.timezoneService
    //     .get()(this.endDate)
    //     .format("MMM Do YYYY");

    //   this.options.endDate = this.endDate;
    // } else {
    //   /**
    //    * Current time is within restaurant hours
    //    * Date set would be today and tomorrow
    //    */
    //   console.log("today and tomorrow")
    //   hour = Number(EndOfHourByDay.split([":"])[0]);
    //   minutes = Number(EndOfHourByDay.split([":"])[1]);
    //   this.endDate = this.timezoneService
    //     .get()(this.endDate)
    //     .add(1, "days")
    //     .set({ hours: hour })
    //     .set({ minutes });
    //   this.endDateDisplay = this.timezoneService
    //     .get()(this.endDate)
    //     .format("MMM Do YYYY");

    //   this.options.endDate = this.endDate;
    // }

    // if (this.ClosingDay === "Same Day") {
    //   hour = Number(EndOfHourByDay.split([":"])[0]);
    //   minutes = Number(EndOfHourByDay.split([":"])[1]);
    //   this.endDate = this.timezoneService
    //     .get()(this.startDate)
    //     .add(0, "days")
    //     .set({ hours: hour })
    //     .set({ minutes });
    //   this.options.endDate = this.options.startDate;
    //   this.endDateDisplay = this.timezoneService
    //     .get()(this.options.endDate)
    //     .format("MMM Do YYYY");
    // }

    // this.startDateDisplay = this.startDate.unix();
    // this.endDateDisplay = this.endDate.unix();
    // console.log("this.startDateDisplay222", this.startDateDisplay);
    // console.log("this.endDateDisplay222", this.endDateDisplay);
    // }

    if (state === "firstLoad") {
      console.log("THIS_IS_FIRST_LOAD");
      let StartOfHourByDay: any = localStorage.getItem("StartOfHourByDay") || "00:00";
      let EndOfHourByDay: any = localStorage.getItem("EndOfHourByDay") || "23:59";
      let ClosingDayValue: any = localStorage.getItem("ClosingDay");
      const startHour = Number(StartOfHourByDay.split([":"])[0]);
      const startMinutes = Number(StartOfHourByDay.split([":"])[1]);
      console.log("startHour", startHour);
      console.log("startMinutes", startMinutes);
      // let startDateWithTime = this.getCustomDate(this.startDate, startHour, startMinutes);
      this.startDate = this.timezoneService
        .get()(this.startDate)
        .hour(startHour)
        .minute(startMinutes);
      this.startDateDisplay = this.timezoneService
        .get()(this.startDate)
        .format("MMM Do YYYY");
      this.startTimeFormatted = this.startDate.format("HH:mm a");
      // console.log("this.startTimeFormatted", this.startTimeFormatted);
      // console.log("THIS>startDate", this.startDate.unix())
      let hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
      let minutes = EndOfHourByDay ?  Number(EndOfHourByDay.split([":"])[1]) : 59;
      this.endDate = this.timezoneService
        .get()(this.endDate)
        .hour(hour)
        .minute(minutes);
      this.endTimeFormatted = this.endDate.format("HH:mm a");
      this.endDateDisplay = this.timezoneService
        .get()(this.endDate)
        .format("MMM Do YYYY");

      this.options.startDate = this.startDate;

      this.ClosingDay = ClosingDayValue;
      let dateTimeToday = this.timezoneService.get()();
      if (
        this.startDate.diff(dateTimeToday) > 0 &&
        this.endDate.diff(dateTimeToday) > 0
      ) {
        /**
         * Current time is before restaurant hours
         * Date set would be yesterday and today
         */
        console.log("yesterday and today");
        this.startDate = this.timezoneService
          .get()(this.startDate)
          .subtract(1, "days");
        this.startDateDisplay = this.timezoneService
          .get()(this.startDate)
          .format("MMM Do YYYY");

        this.options.startDate = this.startDate;
        this.startDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.startDateDisplay)
          .format("MMM Do YYYY");
      } else if (
        this.startDate.diff(dateTimeToday) > 0 &&
        this.endDate.diff(dateTimeToday) < 0
      ) {
        console.log("tomorrow and day after tomorrow");
        /**
         * Current time is after restaurant hours
         * Date set would be tomorrow and day after tomorrow
         */
        this.startDate = this.timezoneService
          .get()(this.startDate)
          .add(1, "days");
        this.startDateDisplay = this.timezoneService
          .get()(this.startDate)
          .format("MMM Do YYYY");
        this.options.startDate = this.startDate;
        this.startDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.startDateDisplay)
          .format("MMM Do YYYY");

        hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
        minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
        this.endDate = this.timezoneService
          .get()(this.endDate)
          .add(2, "days")
          .set({ hours: hour })
          .set({ minutes });
        this.endDateDisplay = this.timezoneService
          .get()(this.endDate)
          .format("MMM Do YYYY");

        this.options.endDate = this.endDate;

        this.endDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.endDateDisplay)
          .format("MMM Do YYYY");
        console.log(
          "this.endDateDisplayFormatted",
          this.endDateDisplayFormatted
        );
      } else {
        /**
         * Current time is within restaurant hours
         * Date set would be today and tomorrow
         */
        console.log("today and tomorrow");
        hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
        minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
        this.endDate = this.timezoneService
          .get()(this.endDate)
          .add(1, "days")
          .set({ hours: hour })
          .set({ minutes });
        this.endDateDisplay = this.timezoneService
          .get()(this.endDate)
          .format("MMM Do YYYY");

        this.options.endDate = this.endDate;

        this.endDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.endDateDisplay)
          .format("MMM Do YYYY");
        console.log(
          "this.endDateDisplayFormatted",
          this.endDateDisplayFormatted
        );
      }

      this.setTimes(startHour, startMinutes, hour, minutes);
      if (this.ClosingDay === "Same Day") {
        hour = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[0]) : 23;
        minutes = EndOfHourByDay ? Number(EndOfHourByDay.split([":"])[1]) : 59;
        this.endDate = this.timezoneService
          .get()(this.startDate)
          .add(0, "days")
          .set({ hours: hour })
          .set({ minutes });
        this.options.endDate = this.options.startDate;
        this.endDateDisplay = this.timezoneService
          .get()(this.options.endDate)
          .format("MMM Do YYYY");

        this.endDateDisplayFormatted = this.timezoneService
          .get()
          .unix(this.endDateDisplay)
          .format("MMM Do YYYY");
        console.log(
          "this.endDateDisplayFormatted",
          this.endDateDisplayFormatted
        );
      }

      this.startDateDisplay = this.startDate.unix();
      this.endDateDisplay = this.endDate.unix();
      console.log("this.startDateDisplay222", this.startDateDisplay);
      console.log("this.endDateDisplay222", this.endDateDisplay);
    }
    this.startDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("MMM Do YYYY");
    this.endDateDisplayFormatted = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("MMM Do YYYY");

    // Destructuring the returned object from the startTimeEndTimeDecimalHours() method.
    // startTimeDecimalHours and endTimeDecimalHours are variables that hold the start and end times in decimal hours.
    // const { startTimeDecimalHours, endTimeDecimalHours } = this.startTimeEndTimeDecimalHours();


    let startTime = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("HH:mm");

    console.log("start date display", this.startDateDisplay);

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

      console.log("end date display", this.endDateDisplay);

    console.log("START - END", typeof(startTime), typeof(endTime));

    // If SuperADmin is logged in, fetch all orders From All Stores
    if (this.isSuperAdmin) {
      this.startDateDisplay = this.isStartDate;
      this.endDateDisplay = this.isEndDate;
      startTime = "00:00";
      endTime = "23:59";
    }

    var data = {
      merchantId: this.merchantId,
      storeId: this.storeId,
      employeeSelected: this.employeeSelected,
      orderTypeSelected: this.orderTypeSelected,
      orderStatusSelected: this.orderStatusSelected,
      orderNumber: this.orderNumber,
      startDateDisplay: this.startDateDisplay,
      endDateDisplay: this.endDateDisplay,
      lastStartDate: this.lastStartDate,
      lastEndDate: this.lastEndDate,
      startTime: startTime,
      endTime: endTime,
      page: this.p,
      items: this.itemsPP,
    };

    this.store.dispatch(salesOrderFetchStart(data));
  }

  /**
   * Calculates the decimal hours for the start time and end time.
   *
   * @returns An object containing the decimal hours for the start time and end time.
   */
  startTimeEndTimeDecimalHours() {
    const endTimeHours = Number(this.endTime.split(".")[0]) || 0;
    const endTimeMinutes = Number(this.endTime.split(".")[1]) || 0;

    const startTimeHours = Number(this.startTime.split(".")[0]) || 0;
    const startTimeMinutes = Number(this.startTime.split(".")[1]) || 0;

    const startTimeDecimalHours = startTimeHours + startTimeMinutes / 60;
    const endTimeDecimalHours = endTimeHours + endTimeMinutes / 60;

    return { startTimeDecimalHours, endTimeDecimalHours };
  }
  //check OrderType Restaurant
  setDineIn = (data: string) => {
    if (data === "Restaurant") {
      return "Dine-In";
    } else {
      return data;
    }
  };
  setSubTypeIcon = (type: any, subType: any) => {
    if (type == 8) {
      var icon = "orderos.png";
      switch (subType) {
        case 5:
          icon = "ubereats.svg";
          break;
        case 6:
          icon = "gh.png";
          break;
        case 7:
          icon = "bitesquad.png";
          break;
        case 8:
          icon = "zuppler.png";
          break;
        case 9:
          icon = "chownow.png";
          break;
        case 10:
          icon = "lovett.png";
          break;
        case 11:
          icon = "palettelogo.jpeg";
          break;
        case 12:
          icon = "hungrypanda.png";
          break;
        case 13:
          icon = "caviar.svg";
          break;
        case 14:
          icon = "postmates.svg";
          break;
        case 15:
          icon = "doordash.png";
          break;
          case 17:
          icon = "zomato.svg";
          break;
          case 18:
          icon = "swiggy.svg";
          break;
          case 21:
          icon = "amazon.svg";
          break;
          case 37:
          icon = "uengage.jpg";
          break;
          case 38:
          icon = "bitsila.png";
          break;
          case 19:
          icon = "dunzo.png";
          break;
          case 20:
          icon = "dotpe.svg";
          break;
          case 39:
          icon = "masalabox.jpeg";
          break;
          case 40:
          icon = "tipplr.png";
          break;
          case 41:
          icon = "rezoy.png";
          break;
          case 42:
          icon = "droptheq.png";
          break;
          case 43:
          icon = "nextdoorhub.png";
          break;
          case 44:
          icon = "fidoo.jpeg";
          break;
          case 33:
          icon = "magicpin.svg";
          break;
          case 31:
          icon = "easydiner.avif";
          break;
          case 45:
          icon = "hungerbox.png";
          break;
          case 46:
          icon = "peppo.jpeg";
          break;
          case 34:
          icon = "gupshup.jpg";
          break;
          case 32:
          icon = "inresto.png";
          break;
          case 47:
          icon = "thrive.jpeg";
          break;
          case 48:
            icon = "swiggy.svg";
          break;
          case 49:
            icon = "ithara.png";
          break;
          case 27:
            icon = "hungerstation.png";
          break;
          case 24:
            icon = "careem.png";
          break;
          case 22:
            icon = "jahez.jpg";
          break;
          case 25:
            icon = "deliveroo.svg";
          break;
          case 23:
            icon = "talabat.png";
          break;
          case 29:
            icon = "radyes.png";
          break;
          case 30:
            icon = "noonfood.png";
          break;
          case 35:
            icon = "chatfood.png";
          break;
          case 50:
            icon = "instashop.png";
          break;
          case 28:
            icon = "mrsool.jpeg";
          break;
          case 36:
            icon = "eateasy.jpeg";
          break;
          case 51:
            icon = "toyou.png";
          break;
          case 52:
            icon = "dca.png";
          break;
          case 53:
            icon = "ordable.jpg";
          break;
          case 54:
            icon = "beanz.jpg";
          break;
          case 55:
            icon = "cari.png";
          break;
          case 56:
            icon = "smiles.png";
          break;
          case 57:
            icon = "thechef.png";
          break;
        default:
          icon = "orderos.png";
          break;
      }
      return icon;
    } else {
      return "pos.png";
    }
  };

  showItemCountPP: any = 0;
  //update page
  updatePage = (event: any) => {
    this.p = event;
    if (this.p === 1) {
      this.showItemCountPP = 0;
    } else {
      this.showItemCountPP = this.p * this.itemsPP - this.itemsPP;
    }
    this.getNumberCountOrders();
  };
  //on data limit change
  onLimitSelected(e) {
    this.showItemCountPP = 0;
    this.itemsPP = e;
    this.p = 1;
    this.getNumberCountOrders();
  }

  NewchangeEmployee(e: any) {
    this.closeFilterCanvas();
    this.showItemCountPP = 0;
    this.p = 1;
    this.employeeSelected = e;
    this.getNumberCountOrders();
  }
  //change employee select
  changeEmployee(e) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.employeeSelected = e.target.value;
    this.getNumberCountOrders();
  }
  async timeout(ms: any) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async filterByOrderId(e) {
    this.showItemCountPP = 0;
    this.p = 1;
    this.orderNumber = e;
    await this.timeout(1450);
    await this.getNumberCountOrders();
  }
  //find child orders in Orders
  findChidlOrders = (childOrders) => {
    if (childOrders) {
      let ordersFound;
      let ordersFilter;
      let orders = [];
      childOrders.map((orderId) => {
        ordersFilter = this.childOrders$.filter((findParentId) => {
          return findParentId.orderId === orderId;
        });
        if (ordersFilter.length !== 0) {
          orders = orders.concat(ordersFilter);
        }
        return orders;
      });
      return orders;
    }
  };
  showChildOrders(index, orderId) {
    let copyOrders = JSON.parse(JSON.stringify(this.orders$));
    const selectedOrderIndex = copyOrders?.findIndex(
      (val) => val.orderId === orderId
    );
    copyOrders[selectedOrderIndex].enableChild =
      !copyOrders[selectedOrderIndex].enableChild;
    this.orders$ = copyOrders;
  }
  ToggleToPositive(test, i) {
    //alert(test)
    var a = i + this.itemsPP * (this.p - 1);
    let copyOrders = JSON.parse(JSON.stringify(this.orders$));
    if (test == 1) {
      // console.log( 'test1' , this.orders[i].toggle);
      copyOrders[i].toggle = false;
      this.orders$ = copyOrders;
    } else if (test == 2) {
      // console.log( 'test2' , this.orders[i].toggle);
      copyOrders[i].toggle = true;
      this.orders$ = copyOrders;
    }
  }
  getStringCountFromArray(stringArray) {
    let count = 0;
    if (stringArray) {
      stringArray.forEach((prodName) => {
        count += prodName.productName.length;
      });
      return count;
    } else {
      return 0;
    }
  }
  index: any = 0;
  deliveryAmount: any;
  promoCodeValue: any;
  orderReceipt: any = [];
  paymentReceipt: any = {};
  // singleTransactionOrderId: any;
  // orderQuantityArr: any;

  modifierValidation: any = "0";
  /**
   * Open modal
   * @param content modal content
   */
  openModal(content: any, Order1Selected: any, j: Number) {
    this.backtoTransactionDetail();
    this.modifierValidation = "0";
    console.log("When-clicked-on-orders-modal", Order1Selected);
    // let copyObj = Order1Selected

    //## DEEP COPY WITH JSON TO UPDATE THE VALUES IN MODAL
    let copyObj = JSON.parse(JSON.stringify(Order1Selected));

    console.log("Order1Selected", copyObj);
    this.selectedOrderId = Order1Selected.orderId;
    // this.singleTransactionOrderId = copyObj.orderId;
    // this.transactionService.getSingleOrderPayments(copyObj.paymentId).subscribe( (response) => {
    //   console.log("SINGLE_TRANSACTION", response)
    // })
    //## IF USING SHARED RECIEPT MODALS COMPONENTS
    // this.paymentReceipt = {
    //   orderId: copyObj
    // };
    // console.log("Order1Selected.orderSellStatus", Order1Selected.orderSellStatus)
    // console.log("Order1Selected.orderStatusName", Order1Selected.orderStatusName)
    // if(Order1Selected.orderSellStatus == 4 && Order1Selected.orderStatusName == 'Completed') {
    //   this.disableCloseBtn = true;
    // } else {
    //   this.disableCloseBtn = false;
    // }

    if (copyObj?.product) {
      copyObj.product.forEach((element2) => {
          var temp = [];
          element2.productModifiers.forEach((element3, index) => {
            console.log("MODIFIER VALIDATION", this.modifierValidation);
            console.log("ELEMENT 3 MODIFIER GROUP ID", element3.modifierGroupId);
            if (
              element3.hasMultipleOptions == true &&
              this.modifierValidation == element3.modifierGroupId
            ) {

              if (index == 0) {
                temp.push({
                  modifierName: element3.modifierName,
                  childrens: [
                    {
                      modifierOptionName: element3.modifierOptionName,
                    },
                  ],
                });
              } else {
                temp[temp.length - 1].childrens.push({
                  modifierOptionName: element3.modifierOptionName,
                });
              }
            } else {
              temp.push({
                modifierName: element3.modifierName,
                childrens: [
                  {
                    modifierOptionName: element3.modifierOptionName,
                  },
                ],
              });
            }
            this.modifierValidation = element3.modifierGroupId;
            element2.AllproductModifiers = temp;
          });
          element2.modifierGroupById = _(element2.productModifiers)
            .groupBy("modifierId")
            .map((modifier, id) => ({
              modifierTotalPrice: _.sumBy(modifier, "modifierPrice"),
              modifierName: modifier[0].modifierName,
              modifierOptions: modifier,
            }))
            .value();
      });
    }

    this.orderReceipt = copyObj;
    this.paymentReceipt = copyObj;
    console.log("this.paymentReceipt", this.paymentReceipt);

    // Check if orderStatusName is all types of refunds, Voided, or Cancelled and disable close button
    console.log("ORDER STATUS NAME", copyObj.orderStatusName);
    switch (copyObj.orderStatusName) {
      case "Refunded":
        this.disableCloseBtn = true;
        break;
      case "No Data":
        this.disableCloseBtn = true;
        break;
      case "Cancelled":
        this.disableCloseBtn = true;
        break;
      case "Partially refunded":
        this.disableCloseBtn = true;
        break;
      default:
        this.disableCloseBtn = false;
        break;
    }

    // console.log("this.paymentReceipt", this.paymentReceipt)
    this.globalamount = copyObj.totalAmount;
    // this.orderQuantityArr = copyObj.seats.map( (orderProduct) => {
    //   return orderProduct.orderProducts;
    // })
    // console.log("this.orderQuantityArr", this.orderQuantityArr)
    // this.renderer.addClass(document.body, 'modal-open')
    this.prev = null;
    this.showRefundLoader = false;
    this.showRefundSuccess = false;
    this.showRefundPageTwo = false;
    this.orderReceipt = [];
    this.deliveryAmount = Order1Selected.deliveryAmount;
    this.promoCodeValue = Order1Selected.promoCodeAmount || 0;
    this.orderReceipt = {
      // ...Order1Selected,
      ...copyObj,
      time: this.timezoneService
        .get()
        .unix(Order1Selected.createdAt)
        .format("h:mm A"),
    };
    console.log("this.orderReceipt", this.orderReceipt);
    this.getDiscountNames(this.orderReceipt.seats);
    this.orderReceipt.seats.forEach((product) => {
      product.orderProducts.forEach((products) => {
        if (this.refundProductList.length) {
          const foundProduct = this.refundProductList.find(
            (data) => data.orderedProductId == products.orderedProductId
          );
          if (foundProduct) {
            const index = this.refundProductList.indexOf(foundProduct);
            this.selectedQuantity[products.orderedProductId] =
              this.refundProductList[index].productQuantity;
            console.log(
              "FOUND_QUANTITY",
              this.selectedQuantity[products.orderedProductId]
            );
            // console.log("FOUND_PREV_QUANTITY", this.prevQuantity)
          } else if (!foundProduct) {
            this.selectedQuantity[products.orderedProductId] =
              products.productQuantity;
            console.log(
              "NOT_FOUND_QUANTITY",
              this.selectedQuantity[products.orderedProductId]
            );
          }
          // this.refundProductList.forEach((data) => {
          //     this.selectedQuantity[variant.orderedProductId] = data.productQuantity;
          //       // return data;
          //     });
        } else {
          this.selectedQuantity[products.orderedProductId] =
            products.productQuantity;
        }
        console.log(
          "this.selectedQuantity[products.orderedProductId]",
          this.selectedQuantity[products.orderedProductId]
        );
        console.log("PRODUCTS", products);
      });
    });
    this.index = j;
    // this.modalService.open(
    //   content,
    //   {
    //     windowClass: 'right animate__animated animate__slideInRight'
    //   }
    // );
    this.openEnd(content);
  }

  prev: any;
  newLine(curr) {
    if (this.prev) {
      if (this.prev.modifierId !== curr.modifierId) {
        return true;
      }
    }
    this.prev = curr;
  }

  _convertDateKeys = {};
  _convertDate = (id: string, date: any) => {
    if (!this._convertDateKeys[id]) {
      if (date) {
        this._convertDateKeys[id] = this.timezoneService
          .get()(date * 1000)
          .format("MMM DD, YYYY");
      } else {
        return "";
      }
    }
    return this._convertDateKeys[id];
  };

  convertDate(timeStamp: number) {
    if (timeStamp) {
      return this.timezoneService
        .get()(timeStamp * 1000)
        .format("MMM DD, YYYY");
    } else {
      return "";
    }
  }

  isCheckedFunc(product: any) {
    // console.log("refundProductList", this.refundProductList.length);
    const existingObj = this.refundProductList.find(
      (currentProduct) =>
        currentProduct.orderedProductId === product.orderedProductId
    );
    if (existingObj) {
      return true;
    } else {
      return false;
    }
  }

  _convertTimeKeys = {};
  _convertTime = (id: string, date: any) => {
    if (!this._convertTimeKeys[id]) {
      if (date) {
        this._convertTimeKeys[id] = this.timezoneService
          .get()
          .unix(date)
          .format("h:mm A");
      } else {
        return "";
      }
    }
    return this._convertTimeKeys[id];
  };

  convertTime(timeStamp: number) {
    if (timeStamp) {
      return this.timezoneService.get().unix(timeStamp).format("h:mm A");
    } else {
      return "";
    }
  }

  openEnd(orderdetail: TemplateRef<any>) {
    this.offcanvasService.open(orderdetail, { position: "end" });
  }
  closeModal(content: any) {
    console.log("CLOSE MODAL");
    // this.renderer.removeClass(document.body, "modal-open");
    this.showRefundLoader = false;
    this.showRefundSuccess = false;
    this.showRefundPageTwo = true;
    this.showReceiptPage = false;
    this.showRefundPage = false;
    this.showEditPageDetails = false;
    // this.showOrderDetailPage = false;
    this.refundReason = "";
    this.noteReason = "";
    this.modalService.dismissAll(content);
    this.prev = null;
    this.backtoTransactionDetail();
    this.backtoOrderDetails();
  }
  sum(a, b) {
    +a;
    +b;
    return (a * 1 * (b * 1)).toFixed(2);
    // return a * b;
  }
  // getPriceForRecipe = (unitPrice, quantity) => {
  //   return quantity * unitPrice;
  // };
  email: string = "";
  emailMsg: string = "";

  // validateEmail() {
  //   if (
  //     !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
  //       this.email
  //     )
  //   ) {
  //     this.emailMsg = "Please enter a valid email";
  //     return;
  //   } else {
  //     this.emailMsg = "";
  //   }
  // }
  validateEmail() {
    if (!this.email) {
      this.emailMsg = ""; // Clear the error message when the input is empty
    } else if (
      !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.email
      )
    ) {
      this.emailMsg = "Please enter a valid email";
    } else {
      this.emailMsg = ""; // Clear the error message when the email is valid
    }
  }
  errormsg: boolean = false;
  phone: any = "";
  phoneMsg: boolean = false;
  // validatePhone() {
  //   const phoneNumber = this.phone?.number;
  //   if (phoneNumber) {
  //     const phoneRegex = /^(?:\+\d{1,3}\s?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
  //     if (!phoneRegex.test(phoneNumber)) {
  //       this.phoneMsg = true;
  //     } else {
  //       this.phoneMsg = false;
  //     }
  //   }
  // }
  validatePhone() {
    if (!this.phone) {
      // Handle empty phone number
      return;
    }

    console.log("THIS>PHONE_OBJ", this.phone);
    const phoneUtil = PhoneNumberUtil.getInstance();

    try {
      const phoneNumber = phoneUtil.parse(this.phone.internationalNumber);
      if (phoneUtil.isValidNumber(phoneNumber)) {
        // Valid phone number
        const formattedNumber = phoneUtil.format(
          phoneNumber,
          PhoneNumberFormat.NATIONAL
        );
        console.log("VALID_NUM", formattedNumber);
        this.phoneMsg = false; // No need to show a validation message
      } else {
        console.log("INVALID_NUM");
        this.phoneMsg = true; // Show a validation message
      }
    } catch (e) {
      console.log("INVALID_NUM");
      this.phoneMsg = true; // Show a validation message for invalid input
    }
  }

  backtoTransactionDetail() {
    this.refundProductList = [];
    this.noteReason = "";
    this.refundReason = "";
    this.phoneMsg = false;
    // this.receiptModal = false;
    // this.refundModalPageOne = false;
    // this.refundModalPageTwo = false;
    // this.refundModalLoader = false;
    // this.refundModalSuccess = false;
    // this.pRefundModalPageOne = false;
    // this.cRefundModalPageOne = false;totalPartialRefund
    // this.pRefundModalPageTwo = false;
    // this.cRefundModalPageTwo = false;
    this.showOrderDetailPage = true;
    this.showEditPageDetails = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.orderEditModalPageThree = false;
    this.showReceiptPage = false;
    this.showRefundPage = false;
    // this.refundProductList = [];
    // this.totalPartialRefund = 0.0;
    // this.partialRefundActive = false;
  }

  showEditPageDetails: Boolean = false;
  showReceiptPage: Boolean = false;
  showRefundPage: Boolean = false;
  showRefundPageTwo: Boolean = false;
  showOrderDetailPage: Boolean = true;
  globalOrderId: any = "";
  globaltip = 0;
  globalamount = 0;
  orderStatus: any = "";

  getTaxNames(): string {
    const taxNamesSet = new Set<string>();

    if (
      this.orderReceipt.seats !== undefined &&
      this.orderReceipt.seats !== null
    ) {
      for (const seat of this.orderReceipt.seats) {
        for (const orderProduct of seat.orderProducts) {
          for (const productTax of orderProduct.productTax) {
            let taxPhrase = "";
            if (productTax.taxType !== 1) {
              taxPhrase = `${productTax.taxName} @${productTax.taxValue.toFixed(
                2
              )}$`;
              taxNamesSet.add(taxPhrase);
            } else {
              taxPhrase = `${productTax.taxName} @${productTax.taxValue}%`;
              taxNamesSet.add(taxPhrase);
            }
          }
        }
      }
    }

    const taxNamesPhrase = Array.from(taxNamesSet).join(", ");

    return taxNamesPhrase;
  }

  sendReceipt(order: any) {
    this.showReceiptPage = true;
    this.showRefundPage = false;
    this.showRefundPageTwo = false;
    this.showOrderDetailPage = false;
    this.globalamount = 0;
    this.globaltip = 0;
    this.globalOrderId = "";
    this.email = "";
    this.phone = "";
    this.phoneMsg = false;
    this.globalOrderId = order.orderId;
    this.globalamount = order.totalAmount;
  }
  fullrefund(order: any, type) {
    if (type === "partial") {
      this.fundType = "PARTIAL REFUND";
      // this.checkRefundProductList();
      // this.globalamount = 0;
    } else if (type === "edit") {
      this.fundType = "Edit";
    } else {
      this.fundType = "FULL REFUND";
    }
    this.showReceiptPage = false;
    this.showRefundPage = true;
    this.showOrderDetailPage = false;
    this.globalamount = 0;
    this.globaltip = 0;
    this.globalOrderId = "";
    this.email = "";
    this.phone = "";
    this.emailMsg = "";
    this.orderStatus = "";
    this.globalOrderId = order.orderId;
    this.globalamount = order.totalAmount;
    this.orderStatus = order.orderSellStatus;
  }

  selectedQuantity: { [orderedProductId: string]: number } = {};
  pRefundModalAmount = 0;
  addProductsInListToRefund(product: any, event: any) {
    this.globalamount = 0;
    // const isTheProductOnList = this.refundProductList.find(
    //   (currentProduct: any) => {
    //     return currentProduct.orderedProductId === product.orderedProductId;
    //   }
    // );
    // if (isTheProductOnList === undefined) {
    //   this.refundProductList.push(product);
    // } else {
    //   this.refundProductList = this.refundProductList.filter(
    //     (currentProduct: any) => {
    //       return currentProduct.orderedProductId !== product.orderedProductId;
    //     }
    //   );
    // }
    // this.globalamount = this.refundProductList.reduce((acc, obj) => {
    //   return acc + obj.productUnitPrice * obj.productQuantity;
    // }, 0);
    // this.pRefundModalAmount = this.globalamount;
    let value = event.target.checked;
    console.log("value", event);
    // Add the 'ShouldRemove' property to the product object
    product.shouldRemove = value;
    if (value) {
      // If value is true call the 'addProductsInListToRefund2'
      console.log(
        "this.selectedQuantity[product.orderedProductId]",
        this.selectedQuantity[product.orderedProductId]
      );
      const productCopy = JSON.parse(JSON.stringify(product));
      // this.prevQuantity = quantity;
      if (this.selectedQuantity[product.orderedProductId]) {
        // Convert the quantity to a number
        productCopy.productQuantity =
          this.selectedQuantity[product.orderedProductId];
        // product.productQuantity = quantity;
      }
      // Emit the updated product object
      console.log("PRODUCT_EMITTED");
      // this.checkingCheckboxValue = true;
      // this.addProductsInListToRefund.emit(productCopy);
      this.addProductsInListToPartialRefund(productCopy);
    } else {
      // this.addProductsInListToRefund.emit({product, value});
      // this.addProductsInListToRefund.emit(product);
      this.addProductsInListToPartialRefund(product);
    }
  }

  addProductsInListToRefund2(product, event) {
    const productCopy = JSON.parse(JSON.stringify(product));
    this.selectedQuantity[product.orderedProductId] = event;
    if (event) {
      // product.productQuantity = event;
      productCopy.productQuantity = event;

      // this.globalamount = this.refundProductList.reduce((acc, obj) => {
      //   return acc + obj.productUnitPrice * obj.productQuantity;
      // }, 0);
      // this.pRefundModalAmount = this.globalamount;
      this.addProductsInListToPartialRefund(productCopy);
    }
  }

  addProductsInListToPartialRefund(product: any) {
    console.log("product", product);
    this.pRefundModalAmount = 0;

    const productIndex = this.refundProductList.findIndex(
      (currentProduct) =>
        currentProduct.orderedProductId === product.orderedProductId
    );

    if (productIndex !== -1) {
      // const updatedProduct = { ...product };
      // this.refundProductList[productIndex] = updatedProduct;
      if (product.shouldRemove === false) {
        console.log("PRODUCT_REMOVED");
        this.refundProductList.splice(productIndex, 1);
      } else {
        const updatedProduct = { ...product };
        this.refundProductList[productIndex] = updatedProduct;
        console.log("PRODUCT_ADDEDDD");
      }
    } else {
      this.refundProductList.push(product);
      console.log("PRODUCT_ADDEDDD");
    }
    // this.globalamount = this.refundProductList.reduce((acc, obj) => {
    //     return acc + obj.productCalculatedPrice;
    //   }, 0);
    //   this.pRefundModalAmount = this.globalamount;
    if (product.productModifiers) {
      this.globalamount = this.refundProductList.reduce((acc, obj) => {
        // Calculate the total price of the modifiers
        let modTotalPrice = obj.productModifiers.reduce((acc, obj) => {
          return acc + obj.modifierPrice;
        }, 0);
        modTotalPrice = modTotalPrice * obj.productQuantity;
        return acc + obj.productUnitPrice * obj.productQuantity + modTotalPrice;
      }, 0);
      this.pRefundModalAmount = this.globalamount;
    } else {
      this.globalamount = this.refundProductList.reduce((acc, obj) => {
        return acc + obj.productUnitPrice * obj.productQuantity;
      }, 0);
      this.pRefundModalAmount = this.globalamount;
    }
    console.log("this.refundProductList_LENGTH", this.refundProductList.length);
  }

  // getQuantityList = (qty:number) => Array.from({ length: qty }).map((v, i) => i + 1);

  // getQuantityList = (product) => {
  //   // console.log("PRODUCT_FROM_PARTIAL_DROPDOWN", product)
  //   let qty = product.productQuantity;
  //   if (!this.tempData[product.orderedProductId]) {
  //     this.tempData[product.orderedProductId] = [];
  //     while (qty > 0) {
  //       this.tempData[product.orderedProductId].push(qty);
  //       qty--;
  //     }
  //     // return this.tempData[product.orderedProductId]
  //   }
  //   // else{
  //   return this.tempData[product.orderedProductId];
  //   // }
  // };
  getQuantityList = (product) => {
    // console.log("VARIANTS_", product)
    const variantsCopy = { ...product };
    let qty = variantsCopy.productQuantity;
    if (!this.tempData[variantsCopy.orderedProductId]) {
      this.tempData[variantsCopy.orderedProductId] = [];
      while (qty > 0) {
        this.tempData[variantsCopy.orderedProductId].push(qty);
        qty--;
      }
    }
    return this.tempData[variantsCopy.orderedProductId];
  };

  idInterval: any;
  timeToVerify: any = 0;
  timerDisplay: string = "5:00";
  runTime() {
    let ini = 0;
    this.timeToVerify = 300;
    this.idInterval = setInterval(() => {
      if (this.timeToVerify > 0) {
        this.timeToVerify = this.timeToVerify - 1;
        this.timerDisplay = this.formatTimer(this.timeToVerify);
      } else if (this.timeToVerify >= 0 && ini < 2) {
        this.toastr.error("OTP code has expired");
        ini++;
        clearInterval(this.idInterval);
      }
    }, 1000);
  }
  formatTimer(seconds: number) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const paddedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
    return `${minutes}:${paddedSeconds}`;
  }
  isVerificationOk(code) {
    this.buttonApprove = false;
    var parameters: any;
    if (
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.account
      )
    ) {
      parameters = {
        otp: code,
        username: this.account,
      };
    } else {
      parameters = {
        otp: code,
        mobile: this.account,
      };
    }
    return this.http
      .post(this.GLOBALURL + "/user/verifyOTP", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 1) {
            // this.nextPage()
            this.buttonApprove = true;
            // this.toastr.success(response.message);
            clearInterval(this.idInterval);
          } else {
            this.buttonApprove = false;
            // this.toastr.error(response.message);
          }
        },
        (error) => {
           const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }

  nextPage() {
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = true;
    this.orderEditModalPageThree = true;
  }

  changeValueSelect(event: any) {
    this.userSelected = event;
  }
  changeEditTipAmount(event) {
    this.tipAmount = event;
  }
  clearEditOrder() {
    this.editPayment = {};
    this.userSelected = "";
    this.tipAmount = "";
    this.editTransaction = {};
  }
  chageLoader: Boolean = false;

  changeTipFunction(content) {
    this.updateOrder(content);
    // this.selectTransactionEditOrder();
    // console.log("CHANGE_TIP_FUNCTION", content);
    // var parameters = {
    //   // transactionId: this.editTransaction.transactionId,
    //   // tipAmount: this.tipAmount,
    //   orderId: this.paymentReceipt.orderId,
    //   employeeId: this.userSelected,
    // };
    // let payments = JSON.parse(JSON.stringify(this.transactions$));
    // this.chageLoader = true;
    // return this.http
    //   .put(this.GLOBALURL + "/order/server", parameters, this.httpOptions1)
    //   .subscribe(
    //     (response: any) => {
    //       if (response.success == 1) {
    //         payments[this.index] = response.response;
    //         this.transactions$ = payments;
    //         this.toastr.success(response.message);
    //         this.chageLoader = false;
    //         this.clearEditOrder();
    //         this.paymentReceipt = { ...response.response };
    //         let index = this.transactions$?.findIndex(
    //           (obj) => obj.paymentId === response.response.paymentId
    //         );

    //         if (index !== -1) {
    //           const updatedObject = { ...this.paymentReceipt };
    //           const newArr = [...this.transactions$];
    //           this.transactions$ = [];
    //           newArr[index] = updatedObject;
    //           this.transactions$ = [...newArr];
    //         }

    //         this.modalService.dismissAll(content);
    //         this.backtoTransactionDetail();
    //       } else {
    //         this.chageLoader = false;
    //         this.toastr.error(response.message);
    //       }
    //     },
    //     (error) => {
    //       this.chageLoader = false;
    //        const message = this.ApiService.errorMessage(error);
          // this.toastr.error(message);
    //     }
    //   );
  }
  cleanOtp() {
    // this.childRef.clearOtp();
  }

  canResendOTP = true;
  resendOtpEditOrder() {
    if (this.canResendOTP) {
      this.canResendOTP = false;
      var parameters: any;
      if (
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          this.account
        )
      ) {
        parameters = {
          type: 1,
          username: this.account,
        };
      } else {
        parameters = {
          type: 2,
          mobile: this.account,
        };
      }
      this.timeToVerify = 180;
      return this.http
        .post(this.GLOBALURL + "/user/sendotp", parameters, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.success == 0) {
            } else {
              this.toastr.success("OTP has been re-sended");
              this.runTime();
              this.cleanOtp();
            }
          },
          (error) => {
             const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
          }
        );
    } else {
      this.toastr.error("Wait until timer is out");
      this.canResendOTP = true;
    }
  }

  buttonApprove: boolean = false;
  editOrderLoader: Boolean = false;
  orderEditModalPageOne = false;
  orderEditModalPageTwo = false;
  account: any = "";
  editOrder(order: any) {
    // this.showEditPageDetails = true;
    this.editOrderLoader = true;
    var parameters: any;
    if (
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
        this.account
      )
    ) {
      parameters = {
        type: 1,
        username: this.account,
      };
    } else {
      parameters = {
        type: 2,
        mobile: this.account,
      };
    }
    return this.http
      .post(this.GLOBALURL + "/user/sendotp", parameters, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success == 0) {
            this.toastr.error(response.message);
            this.editOrderLoader = false;
            // this.editOrdenSecondStep = true;
          } else {
            this.editOrderLoader = false;
            this.showEditPageDetails = true;
            this.orderEditModalPageOne = true;
            this.orderEditModalPageTwo = false;
            this.showReceiptPage = false;
            this.showRefundPage = false;
            this.showOrderDetailPage = false;
            this.globalamount = 0;
            this.globaltip = 0;
            this.globalOrderId = "";
            this.email = "";
            this.phone = "";
            this.emailMsg = "";
            this.orderStatus = "";
            this.globalOrderId = order.orderId;
            this.globalamount = order.totalAmount;
            this.orderStatus = order.orderSellStatus;
            // this.orderEditModalPageTwo = false;
            this.runTime();
          }
        },
        (error) => {
          this.editOrderLoader = false;
           const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }
  showRefundPageNex() {
    this.showRefundPageTwo = true;
  }
  backtoRefundPageOne() {
    this.showRefundPageTwo = false;
  }

  checkRefundProductList() {
    // console.log("refundProductList", typeof(this.refundProductList.length))
    if (this.refundProductList.length == 0) {
      // console.log("PRODUCT_LIST_TRUe");
      return true;
    } else {
      // console.log("PRODUCT_LIST_FALSE");
      return false;
    }
  }

  userSelected: any;
  editPayment: any = {};
  editTransaction: any = {};
  tipAmount: any = 0.0;
  orderEditModalPageThree = false;
  selectTransactionEditOrder(ts?) {
    this.editPayment = {};
    this.editTransaction = {};
    this.editTransaction = ts.transaction;
    this.userSelected = ts.paymentReceipt.orderId.serverId.employeeId;
    this.editPayment = ts.paymentReceipt;
    this.tipAmount =
      this.editPayment.transactionIds[
        this.editPayment.transactionIds.length - 1
      ].transactionTipAmount;
    this.orderEditModalPageThree = true;
  }

  backtoOrderDetails() {
    this.emailMsg = "";
    this.phone = "";
    this.phoneMsg = false;
    this.showReceiptPage = false;
    this.showRefundPage = false;
    this.showOrderDetailPage = true;
    this.showRefundPageTwo = false;
    this.showEditPageDetails = false;
    this.orderEditModalPageOne = false;
    this.orderEditModalPageTwo = false;
    this.refundProductList = [];
  }
  httpOptions1 = { headers: new HttpHeaders(this.headerToken) };
  sendReceiptMobile() {
    this.disableSendbtn = false;
    var params = {
      mobile: this.phone.internationalNumber,
      orderId: this.globalOrderId,
    };
    return this.http
      .post(this.GLOBALURL + "/receipt", params, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success === 1) {
            this.disableSendbtn = true;
            this.toastr.success(response.message);
            this.backtoOrderDetails();
          } else {
            this.disableSendbtn = true;
            this.toastr.error(response.message);
          }
        },
        (error) => {
          this.disableSendbtn = true;
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }

  sendReceiptToEmail() {
    if (this.email.trim() == "") {
      this.emailMsg = "Please enter a valid email";
      return;
    }
    if (this.emailMsg != "") {
      return;
    }
    this.disableSendbtn = false;
    var params = {
      email: this.email,
      orderId: this.globalOrderId,
    };
    return this.http
      .post(this.GLOBALURL + "/receipt", params, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success === 1) {
            this.disableSendbtn = true;
            this.toastr.success(response.message);
            this.backtoOrderDetails();
          } else {
            this.disableSendbtn = true;
            this.toastr.error(response.message);
            //jQuery('#sendReceipts').modal('hide');
          }
        },
        (error) => {
          this.disableSendbtn = true;
          const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }

  exportReport = (file: String) => {
    this.offcanvasService.dismiss("cross click");
    this.OpenDetails = "mainMenu";
    this.store.dispatch(setLoadingSpinner({ status: true }));
    let copyOrder = [...this.orders$];
    // if (this.startTime != "") {
    //   const hour = 0;
    //   const minutes = 0; // since we dont select mins in drop down
    //   this.startDateDisplay = this.timezoneService
    //     .get()(this.startDate)
    //     .subtract(0, "days")
    //     .set({ hours: hour })
    //     .set({ minutes: minutes })
    //     .unix();
    // }
    // if (this.endTime != "") {
    //   const hour2 = 23;
    //   const minutes2 = 59; // since we dont select mins in drop down
    //   this.endDateDisplay = this.timezoneService
    //     .get()(this.endDate)
    //     .subtract(0, "days")
    //     .set({ hours: hour2 })
    //     .set({ minutes: minutes2 })
    //     .unix();
    // }

    // get start time and end time in HH:mm format
    let startTime = this.timezoneService
      .get()
      .unix(this.startDateDisplay)
      .format("HH:mm");

    let endTime = this.timezoneService
      .get()
      .unix(this.endDateDisplay)
      .format("HH:mm");

    const params = {
      reportName: "order_report",
      format: file,
      query: {
        storeId: this.storeId,
        employeeIds:
          this.employeeSelected === "" ? [] : [this.employeeSelected],
        orderTypes:
          this.orderTypeSelected === ""
            ? []
            : [parseInt(this.orderTypeSelected)],
        orderStatuses:
          this.orderStatusSelected === ""
            ? []
            : [parseInt(this.orderStatusSelected)],
        orderNumber:
          this.orderNumber === "" ? null : parseInt(this.orderNumber),
        startDate: this.startDateDisplay,
        endDate: this.endDateDisplay,
      },
    };

    if (
      (startTime !== "00:00" && endTime === "23:59") ||
      (endTime !== "23:59" && startTime === "00:00") ||
      (startTime !== "00:00" && endTime !== "23:59")
    ) {
      params.query["startTime"] = startTime;
      params.query["endTime"] = endTime;
    }
    //
    // this.myDrop.close();

    this.orderService.export(params).subscribe(
      (response: any) => {
        if (response.error === true) {
          this.toastr.error(response.message);
          this.store.dispatch(setLoadingSpinner({ status: false }));
        } else {
          if (response.data && response.data.url) {
            let headers = new HttpHeaders();
            headers = headers.set("Accept", "application/pdf");
            this.http
              .get(response.data.url, {
                headers: headers,
                responseType: "blob",
              })
              .subscribe((blob: Blob): void => {
                var blob = new Blob([blob], {
                  type: response.data.contentType,
                });
                var url = window.URL.createObjectURL(blob);
                var anchor = document.createElement("a");
                anchor.download = response.data.name;
                anchor.href = url;
                anchor.click();
              });
            this.store.dispatch(setLoadingSpinner({ status: false }));
            setTimeout(() => {
              this.toastr.success("File exported");
            }, 1000);
          } else {
            console.error("URL is undefined or empty.");
          }
          this.toastr.success(response.message);
          this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      },
      (err) => {
        this.toastr.error(err.message);
        this.store.dispatch(setLoadingSpinner({ status: false }));
      }
    );
  };
  refundReason: String = "";
  noteReason: String = "";
  getReasonNote(e: String) {
    this.noteReason = e;
  }
  getReason(e: String) {
    this.refundReason = e;
  }

  // Create a Function that returns boolean value according to the 'this.refundReason' value
  // If the 'this.refundReason' is empty return true, otherwise return false
  // This function will be used to disable the 'Refund' button
  isRefundReasonEmpty = () => {
    if (this.refundReason === "") {
      return true;
    } else {
      return false;
    }
  };

  orders: any[] = [];
  orderProducts: any[] = [];
  showRefundLoader: Boolean = false;
  showRefundSuccess: Boolean = false;
  refundOrder() {
    console.log('REFUND ORDER');
    this.orders = [...this.orders$];
    if (this.orderStatus == 4 || this.orderStatus == 5) {
      this.showRefundLoader = true;
      let params: any = {
        reason: this.refundReason,
        orderId: this.globalOrderId,
        notes: this.noteReason,
      };
      if (this.refundReason !== "" && this.refundProductList.length !== 0) {
        params = {
          reason: this.refundReason,
          orderId: this.globalOrderId,
          orderProducts: this.refundProductList.map((product) => {
            return {
              orderProductId: product.orderedProductId,
              quantity: Number(product.productQuantity),
            };
          }),
          notes: this.noteReason,
        };
      }

      // Updated the Refund API Endpoint('/payment/refund') to '/payment/refund/new'
      return this.http
        .post(this.GLOBALURL + "/payment/refund/new", params, this.httpOptions1)
        .subscribe(
          (response: any) => {
            if (response.success === 1) {
              this.toastr.success(response.message);
              this.orders[this.index] = response.response.orderId;
              this.orders[this.index]["paymentAmount"] = response.response.paymentAmount;
              this.orderProducts = [];
              response?.response?.orderId?.seats?.forEach((element2) => {
                element2.orderProducts.forEach((element3) => {
                  this.orderProducts.push(element3);
                  this.orders[this.index].product = this.orderProducts;
                });
              });
              if (this.orders[this.index].orderSellStatus == 1) {
                this.orders[this.index].orderStatusName = "Ordering";
              } else if (this.orders[this.index].orderSellStatus == 2) {
                this.orders[this.index].orderStatusName = "Payment in progress";
              } else if (this.orders[this.index].orderSellStatus == 3) {
                this.orders[this.index].orderStatusName = "Paid";
              } else if (this.orders[this.index].orderSellStatus == 4) {
                this.orders[this.index].orderStatusName = "Completed";
                this.disableCloseBtn = true;
              } else if (this.orders[this.index].orderSellStatus == 5) {
                this.orders[this.index].orderStatusName = "Partially refunded";
              } else if (this.orders[this.index].orderSellStatus == 6) {
                this.orders[this.index].orderStatusName = "Refunded";
              } else if (this.orders[this.index].orderSellStatus == 7) {
                this.orders[this.index].orderStatusName = "Cancelled";
              } else {
                this.orders[this.index].orderStatusName = "No Data";
              }
              if (
                this.orders[this.index].serverId ||
                this.orders[this.index].serverId !== null
              ) {
                this.orders[this.index].employeeCompleteName =
                  this.orders[this.index].serverId?.employeeFirstName +
                  " " +
                  this.orders[this.index].serverId?.employeeLastName;
              } else {
                this.orders[this.index].employeeCompleteName = "No Employee";
              }
              if (this.orders[this.index].orderType == 1) {
                this.orders[this.index].orderTypeName = "Restaurant";
              } else if (this.orders[this.index].orderType == 2) {
                this.orders[this.index].orderTypeName = "Bar";
              } else if (this.orders[this.index].orderType == 3) {
                this.orders[this.index].orderTypeName = "Take Out";
              } else if (this.orders[this.index].orderType == 4) {
                this.orders[this.index].orderTypeName = "App";
              } else if (this.orders[this.index].orderType == 5) {
                this.orders[this.index].orderTypeName = "Delivery";
              } else if (this.orders[this.index].orderType == 6) {
                this.orders[this.index].orderTypeName = "Ahead";
              } else if (this.orders[this.index].orderType == 7) {
                this.orders[this.index].orderTypeName = "Banquet";
              } else if (this.orders[this.index].orderType == 8) {
                this.orders[this.index].orderTypeName = "Online Ordering";
              } else if (this.orders[this.index].orderType == 9) {
                this.orders[this.index].orderTypeName = "Drive Thru";
              } else {
                this.orders[this.index].orderTypeName = "No Data";
              }
              this.orders$ = this.orders;
              this.orders$ = [...this.orders$];
              this.orders$[this.index] = { ...this.orders$[this.index], employeeCustomId: response.response?.orderId.serverId.employeeCustomId };

              this.showRefundLoader = false;
              this.showRefundSuccess = true;
            } else {
              this.showRefundLoader = false;
              this.toastr.error(response.message);
            }
          },
          (error) => {
            this.showRefundLoader = false;
            this.showRefundSuccess = false;
            const message = this.ApiService.errorMessage(error);
            this.toastr.error(message);
          }
        );
    }
  }
  checkOrderStatus(status: any) {
    if (status === "Ordering") {
      return "payment-inprogress-status-color";
    }
    if (status === "Completed") {
      return "completed-status-color";
    }
    if (status === "Refunded") {
      return "refunded-status-color";
    }
    if (status === "Paid") {
      return "paid-status-color";
    }
    if (status === "Partially refunded") {
      return "partially-refunded-status-color";
    }
    if (status === "Payment in progress") {
      return "payment-inprogress-status-color";
    }
    if (status === "Cancelled") {
      return "btn-danger";
    }
    if (status === "No Data") {
      // console.log("NO_DATA")
      return "btn-light";
    }
    if (status === "Custom refunded") {
      // console.log("CUSTOM_REFUNDED")
      return "btn-light";
    }
    if (status == 9) {
      // console.log("NO_DATA")
      return "btn-light";
    }
  }

  validateProductIngredients(ingredient: any): string {
    return ingredient.ingredientPrice == 0 ||
      ingredient.ingredientValue == "0.00"
      ? "line-through"
      : "none";
  }

  validateProductRefunded(product: any): string {
    return product.productSellStatus === 6 || product.productSellStatus === 7
      ? "line-through"
      : "none";
  }
  validateProductRefundedcolor(product: any) {
    return product.productSellStatus === 6 || product.productSellStatus === 7
      ? "text-danger"
      : "";
  }

  // get product text
  getJoinedProducts(products) {
    let text = "";

    products?.forEach((e, i) => {
      if (products.length === 1) {
        text += e.productName;
        return;
      }

      if (i < 4) {
        if (i === products.length - 1) {
          text += e.productName;
        } else {
          text += e.productName + ", ";
        }
      }
    });

    if (!text) {
      return "";
    }

    return text;
  }

  // get other product text
  getOtherJoinedProducts(products) {
    let text = "";

    products?.forEach((e, i) => {
      if (products.length === 5) {
        text += e.productName;
        return;
      }

      if (i > 3) {
        if (i === products.length - 1) {
          text += e.productName;
        } else {
          text += e.productName + ", ";
        }
      }
    });

    return text;
  }

  // get other product count
  getOtherJoinedProductCount(products) {
    let count = 0;

    products?.forEach((e, i) => {
      if (products.length === 5) {
        count = 1;
        return;
      }

      if (i > 3) {
        count++;
      }
    });

    return count;
  }

  sortData(data) {
    let datas = data.slice().sort((a, b) => {
      if (a.orderNumber < b.orderNumber) {
        return -1;
      }
      if (a.orderNumber > b.orderNumber) {
        return 1;
      }
      return 0;
    });
    return datas.slice().sort((a, b) => {
      return <any>new Date(b.createdAt) - <any>new Date(a.createdAt);
    });
  }

  updateOrder(order: any) {
    this.closeOrderLoader = true;
    var params = {
      orderId: this.selectedOrderId,
      // employeeId: this.userSelected,
      // orderId: order.orderId,
      serverId: this.userSelected,
      storeId: this.storeId,
      merchantId: this.merchantId,
    };
    // let orders = JSON.parse(JSON.stringify(this.orders$));
    return this.http
      .put(this.GLOBALURL + "/order", params, this.httpOptions1)
      .subscribe(
        (response: any) => {
          if (response.success === 1) {
            this.toastr.success(response.message);
            // orders[this.index] = response.response;
            // this.orders$ = orders;
            this.closeOrderLoader = false;
            this.getNumberCountOrders();
            // closeModal(content);
            this.offcanvasService.dismiss("Cross click");
            // this.closeModal();
            // this.summaryCompRef.increaseCloseTransaction()
          } else {
            this.toastr.error(response.message);
            this.closeOrderLoader = false;
          }
        },
        (error) => {
          this.closeOrderLoader = false;
           const message = this.ApiService.errorMessage(error);
          this.toastr.error(message);
        }
      );
  }

  closeOrder(order: any) {
    console.log("CLOSE_ORDER", order);
    this.closeOrderLoader = true;
    var params = {
      orderId: order.orderId,
      orderSellStatus: 4,
      storeId: this.storeId,
      merchantId: this.merchantId,
    };
    // let orders = JSON.parse(JSON.stringify(this.orders$));
    // return this.http
    //   .put(this.GLOBALURL + "/order", params)
    return this.orderService.closeOrder(order, this.storeId, this.merchantId)
      .subscribe(
        (response: any) => {
          if (response.success === 1) {
            this.toastr.success(response.message);
            // orders[this.index] = response.response;
            // this.orders$ = orders;
            this.closeOrderLoader = false;
            this.getNumberCountOrders();
            // closeModal(content);
            this.offcanvasService.dismiss("Cross click");
            // this.closeModal();
            // this.summaryCompRef.increaseCloseTransaction()
          } else {
            this.toastr.error(response.message);
            this.closeOrderLoader = false;
          }
        },
        (error) => {
          this.closeOrderLoader = false;
          // this.toastr.error(error.error.message);
          const message = this.ApiService.errorMessage(error?.error?.message || error?.message || error);
          this.toastr.error(message);
        }
      );
  }

  OpenDetails = "mainMenu";
  OpenFilterCanva(content1: TemplateRef<any>) {
    this.offcanvasService.open(content1, { position: "end" });
  }
  _getDiscountNames: string;
  // getDiscountNames = (seats: any): void => {
  //   const discountNamesSet = [];
  //   // const seats = receipt?.orderId?.seats
  //   if (seats !== undefined) {
  //     for (let item of seats) {
  //       for (let orderProduct of item.orderProducts) {
  //         const {
  //           productDiscount: { discountName, discountValue },
  //         } = orderProduct;
  //         if (discountName && discountValue) {
  //           discountNamesSet.push(`${discountName} @${discountValue}%`);
  //         }
  //       }
  //     }
  //   }
  //   this._getDiscountNames = discountNamesSet.length
  //     ? `(${discountNamesSet.join(", ")})`
  //     : null;
  // };
  getDiscountNames = (seats:any) : void => {
    const discountNamesSet = [];
    if(seats !== undefined){
      for(let item of seats){
          for(let orderProduct of item.orderProducts){
              const { productDiscount: { discountName, discountValue, discountType } } = orderProduct
              if(discountName && discountValue){
                  let discountSymbol = '';
                  let discountString = '';
                  if (discountType === 1) {
                      discountSymbol = '%';
                      discountString = `${discountName} @ ${discountValue}${discountSymbol}`;
                  } else if (discountType === 2) {
                      discountSymbol = this.currency;
                      discountString = `${discountName} @ ${discountSymbol}${discountValue}`;
                  }
                  discountNamesSet.push(discountString);
              }
          }
      }
  }
    this._getDiscountNames = discountNamesSet.length ? `(${discountNamesSet.join(', ')})` : null
  }

  _getProductLevelDiscountNames: string;
  getProductLevelDiscountNames = (discount:any) => {
    // console.log("DISCOUNT", discount)
    // let discountsObj = [];
    // discountsObj.push(discount);
    // console.log("DISCOUNTS_OBJ", discountsObj)
    const discountNamesSet = [];
    // const seats = receipt?.orderId?.seats
    if(discount != undefined){
      // for(let item of seats){
        // for(let discounts of discountsObj){
          // const { productDiscount: { discountName, discountValue, discountType } } = discounts;
          if(discount.discountName && discount.discountValue){
            let discountSymbol = '';
            if (discount.discountType === 1) {
                discountSymbol = '%';
                discountNamesSet.push(`${discount.discountName} @${discount.discountValue}${discountSymbol}`);
            } else if (discount.discountType === 2) {
                discountSymbol = this.currency;
                discountNamesSet.push(`${discount.discountName} @${discountSymbol}${discount.discountValue}`);
            }
        }
        // }
      // }
    }
    this._getProductLevelDiscountNames = discountNamesSet.length ? `(${discountNamesSet.join(', ')})` : null
    return this._getProductLevelDiscountNames;
  }

  isDropdownOpen = false;
  isDropdownOpen1 = false;
  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.DropDownStyleSet();
  }
  EndDateErr:boolean = false;
  startDateErr:boolean = false;
  IsEmployeeeError: boolean = false;
  IsorderStatusError: boolean = false;
  EmployeeErr:boolean = false;
  OrderTypeErr:boolean = false;
  stardateformate:boolean = false;
  toggleDropdown1() {
    this.IsorderStatusError = !this.IsorderStatusError;

  }
  DropDownStyleSet(){
    setTimeout(() => {
       const elements = this.documents.querySelectorAll(".dropdown");
       elements.forEach((element: any) => {
         this.renderer.removeStyle(element, "z-index");
       });
      }, 1000);

   }
   OrderTypeTorggle(){
     this.OrderTypeErr = !this.OrderTypeErr

   }
   EmployeeToggle(){
     this.EmployeeErr = !this.EmployeeErr

   }

  setDateTexts() {
    setTimeout(() => {
      let ranges = document.querySelectorAll(".ranges li");
      let $ranges = this.createTranslateArr(ranges);

      let months = document.querySelectorAll(".table-condensed .month");
      let $months = this.createTranslateArr(months);

      let buttons = document.querySelectorAll(".drp-buttons .btn");
      let $buttons = this.createTranslateArr(buttons);

      // let days = document.querySelectorAll(".table-condensed thead tr");
      // let first = days[1].querySelectorAll("th");
      // let second = days[3].querySelectorAll("th");
      // let $first = this.createTranslateArr(first);
      // let $second = this.createTranslateArr(second);

      // this.translateArrayOfTexts($first, first);
      this.translateArrayOfTexts($buttons, buttons);
      this.translateArrayOfTexts($ranges, ranges);
      this.translateArrayOfTexts($months, months)

    }, 1);

  }

  createTranslateArr(arr: any) {
    let newArr = [];
    arr.forEach((item) => {
      if (item && typeof item.textContent === 'string') {
        newArr.push(this.translatePipe.transform(item.textContent));
      }
    });
    return newArr;
  }

  translateArrayOfTexts($arrToTranslate: string[], arrOfElements: any) {
    if ($arrToTranslate.length === 0) return;

    forkJoin($arrToTranslate)
      .subscribe(texts => {
        texts.forEach((text, i) => {
          arrOfElements[i].textContent = text;
        });
      },
      (error) => {
        console.error("Error in translating:", error);
      })
  }
}
